import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import AppContext from "./AppContext";

export default function ProtectedRoutes() {
  const { isLoggedIn } = React.useContext(AppContext);
  
  return isLoggedIn() ? <Outlet /> : <Navigate to="/login" />;
}